import { render } from "./AddReview.vue?vue&type=template&id=3ef1235c&scoped=true"
import script from "./AddReview.vue?vue&type=script&lang=js"
export * from "./AddReview.vue?vue&type=script&lang=js"

import "./review.scss?vue&type=style&index=0&id=3ef1235c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef1235c"]])

export default __exports__